import styled from 'styled-components'

export const DepositionsContainer = styled.section`
  width: 100%;
  max-width: 1170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 56px;

  .pagination-container {
    display: flex;
    flex-direction: column;
    position: relative;

    .deposition-pagination {
      position: absolute;
      bottom: -2rem;
      left: 1rem;
      .info-button {
        display: none;
      }
    }

    @media (max-width: 700px) {
      .deposition-pagination {
        bottom: -3rem;
        left: 0;
      }
    }
    @media (max-height: 650px) {
      .deposition-pagination {
        bottom: -2rem;
      }
    }
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 700px) {
    .button-depositions {
      margin-top: 32px;
    }
  }
`
